export const topBarHeight = 60;
export const sideNavWidth = 280;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
